module.exports = __webpack_public_path__ + "static/media/Futura LT Light-01.0ee25d77.svg";